
// Chakra imports
import {
  Flex,
  Text,
  useColorModeValue,
  Icon,
  Button,
  Box,
  InputGroup,
  InputLeftElement,
  IconButton,
  Input,
  FormLabel,
  InputRightElement,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Checkbox,
  CheckboxGroup,
  Stack,
  SimpleGrid,
  Tag,
  TagLabel,
  TagCloseButton,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { MdGroupAdd, MdModeEdit, MdClose, MdDelete } from 'react-icons/md';
import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { HashLoader } from 'react-spinners';
import {
  gameAssignList,
  removeAssignedCohort,
  removeassignedlearner,
} from 'utils/game/gameService';
import { getCohortsPostMan } from 'utils/cohorts/cohorts';
import { gameAssign } from 'utils/leaner/leaner';
import { IoAddCircleSharp } from 'react-icons/io5';
import { GoMoveToEnd } from 'react-icons/go';

const LeanersList = (props: {
  setOpenLearner: any;
  assignGameId: any;
  setMsg: any;
  setToastStatus: any;
  setAlert: any;
}) => {
  const { setOpenLearner, assignGameId, setMsg, setToastStatus, setAlert } =
    props;
  const searchIconColor = useColorModeValue('gray.700', 'white');
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const [fil, setFil] = useState<string>('');
  const [showLearner, setLearner] = useState<any[]>([]);

  const [showAssignList, setAssignList] = useState<any[]>([]);
  const [tab, setTab] = useState<string>('learners');
  console.log(tab,'tanbinlearnerlist')
  const [selectedToggle, setSelectedToggle] = useState<any>([]);

  const [selectedCohorts, setSelectedCohorts] = useState<any>([]);
  const [selectedToggledb, setdbSelectedToggle] = useState<any>([]);
  const [dataToUse, setdataToUse] = useState<any[]>([]);
  const [allSelected, setAllSelected] = useState(false);

  const [gmailList, setGmailList] = useState<string[]>([]); // To store the valid Gmail addresses
  const [showFiltercohorts, setshowFiltercohorts] = useState<any[]>([]);
  const [isPasting, setIsPasting] = useState(false);
  const [isPopupOpen1, setIsPopupOpen1] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [addI, setAddI] = useState(null);
  const user = localStorage.getItem('user');
  const storedUser = JSON.parse(user);
  const [selectedIndices, setSelectedIndices] = useState<number[]>([]);

  const [selectedCohortId, setSelectedCohortId] = useState<number>(null);

  const [SelectedcohortIndices, setSelectedcohortIndices] = useState<number[]>(
    [],
  );

  const [selectedLearnerId, setSelectedLearnerId] = useState<number>(null);

   const [allSelectedLearners, setAllSelectedLearners] = useState(false);  //## Learners select all
 const [allSelectedCohorts, setAllSelectedCohorts] = useState(false);    //## Cohorts select all


  const loginUserId = storedUser.data.id;
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = '0px';
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + 'px';
    }
  }, []);
  const [cohortsList, setCohortsList] = useState<any[]>([]);

  const [selectedLearnerIds, setSelectedLearnerIds] = useState<number[]>([]);
  const [selectedCohortIds, setSelectedCohortIds] = useState<number[]>([]);

  useEffect(() => {
    const learnerIds = selectedIndices
      .map((index) => showLearner[index]?.lenId)
      .filter(Boolean);
    setSelectedLearnerIds(learnerIds);
  }, [selectedIndices, showLearner]);

  useEffect(() => {
    const cohortIds = SelectedcohortIndices.map(
      (index) => cohortsList[index]?.chId,
    ).filter(Boolean);
    setSelectedCohortIds(cohortIds);
  }, [SelectedcohortIndices, cohortsList]);

  useEffect(() => {}, [selectedLearnerIds]);

  useEffect(() => {}, [selectedCohortIds]);
  let borderColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');
  let lightBlue = useColorModeValue('#3311db5c', '#3311db5c');
  let textColor = useColorModeValue('black', 'white');
  const handleClick = (item: any, types: any) => {
    if (types === 'Learner') {
      if (selectedToggle.includes(item)) {
        setSelectedToggle((prevToggle: any) =>
          prevToggle.filter((toggleId: any) => toggleId !== item),
        );
      } else {
        setSelectedToggle((prevToggle: any) => [...prevToggle, item]); // Add the ID to selectedToggle
      }
    } else {
      if (selectedCohorts.includes(item)) {
        setSelectedCohorts((prevToggle: any) =>
          prevToggle.filter((cohortsId: any) => cohortsId !== item),
        );
      } else {
        setSelectedCohorts((prevToggle: any) => [...prevToggle, item]); // Add the ID to selectedToggle
      }
    }
  };

  const [loading, setLoading] = useState(false);



const handleAssign = async () => {
  setLoading(true);

  const data = {
    learnerId: selectedToggle,   // selected learners to assign
    cohortId: selectedCohorts,   // selected cohorts to assign
    gameid: assignGameId,
  };

  const jsonString = JSON.stringify(data);

  try {
    const result = await gameAssign(jsonString);

    console.log("✅ Assign Result:", result);

    if (result?.status !== 'Success') {
      setMsg('The game has not been assigned to any learners.');
      setToastStatus('error');
      setAlert(true);
    } else {
      setMsg('The game has been successfully assigned.');
      setToastStatus('success');
      setAlert(true);

      // Move assigned learners to Enrolled side locally without duplicates
      setSelectedToggle((prev: any) => {
        const newLearners = selectedToggle.filter((id: any) => !prev.includes(id));
        return [...prev, ...newLearners];
      });

      // Move assigned cohorts to Enrolled side locally without duplicates
      setSelectedCohorts((prev: any) => {
        const newCohorts = selectedCohorts.filter((id: any) => !prev.includes(id));
        return [...prev, ...newCohorts];
      });

      // Optionally remove from Choose side
      setLearner((prev: any) => prev.filter((l: any) => !selectedToggle.includes(l.lenId)));
      setCohortsList((prev: any) => prev.filter((c: any) => !selectedCohorts.includes(c.chId)));

      // Keep tab open state consistent
      setOpenLearner(false);

      // 🔢 Console log all assigned cohorts after assignment
      console.log("🏷️ Cohorts assigned (Enrolled):", selectedCohorts);
      console.log("🔢 Total assigned cohorts:", selectedCohorts.length);
    }
  } catch (error) {
    console.error("Error assigning game:", error);
    setMsg('Something went wrong while assigning the game.');
    setToastStatus('error');
    setAlert(true);
  } finally {
    setLoading(false);
  }
};



const getlist = async () => {
  const result = await gameAssignList(assignGameId);
  if (result?.status !== 'Success') return;

  const enrolledCohorts = JSON.parse(result?.cohorts || "[]");
  setSelectedCohorts(enrolledCohorts);
  setLearner(result?.learner);
  setdataToUse(result?.learner);
  setAssignList(result.assign);
  setdbSelectedToggle(result.assign);
  setSelectedToggle(result.assign);

  // Merge all cohorts from DB with already assigned cohorts
  const allCohortsMerged = [
    ...cohortsList, // cohorts fetched from DB
    ...enrolledCohorts
      .map((id: number) => {
        const found = cohortsList.find(c => c.chId === id);
        return found ? found : { chId: id, chCohortsName: `Cohort-${id}` };
      })
  ].filter((v, i, a) => a.findIndex(x => x.chId === v.chId) === i); // remove duplicates

  console.log("📋 All Cohorts including assigned:", allCohortsMerged);
  console.log("🔢 Total cohorts including assigned:", allCohortsMerged.length);
};





  useEffect(() => {
    getlist();
  }, []);
  useEffect(() => {
    const filteredLearnersGmailget = gmailList.length
      ? dataToUse.filter((item) =>
          gmailList
            .map((email) => email.toLowerCase())
            .includes(item.lenMail.toLowerCase()),
        ) // ## Filter learners based on the Gmail list
      : dataToUse;
    setLearner(filteredLearnersGmailget);
  }, [gmailList]);
  useEffect(() => {
    const getCohortsList = async () => {
      const cohrtsresult = await getCohortsPostMan(loginUserId);
      if (cohrtsresult?.status === 'Success') {
        setCohortsList(cohrtsresult?.data);
        setshowFiltercohorts(cohrtsresult?.data);
      }
    };
    getCohortsList();
  }, []);
  const chunkArray = (arr: any, chunkSize: any) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      chunks.push(arr.slice(i, i + chunkSize));
    }
    return chunks;
  };
  const FilterList = (fil: any) => {
    setFil(fil);
    const filteredCohorts = showFiltercohorts.filter((item, index) =>
      item?.chCohortsName && fil
        ? item.chCohortsName.toLowerCase().includes(fil.toLowerCase())
        : false,
    );

    setCohortsList(fil ? filteredCohorts : showFiltercohorts);
    const learnerChunks = chunkArray(dataToUse, 3);
  };
  
const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const checked = e.target.checked;
  setAllSelected(checked);

  if (checked) {
    // ## Select all Learners by their IDs
    const allLearnerIds = showLearner.map(l => l.lenId);
    setSelectedIndices(allLearnerIds);

    // ## Select all Cohorts by their IDs
    const allCohortIds = cohortsList.map(c => c.chId);
    setSelectedcohortIndices(allCohortIds);
  } else {
    // ## Uncheck all
    setSelectedIndices([]);
    setSelectedcohortIndices([]);
  }
};
const handleMoveTo = async () => {
    if (tab === 'learners') {
      const learnersToMove = allSelected
        ? showLearner.map((item: any) => item.lenId)
        : selectedIndices;

      if (learnersToMove.length === 0) return;

      const newToggle = [...new Set([...selectedToggle, ...learnersToMove])];
      setSelectedToggle(newToggle);

      // ✅ Move outside to avoid async timing issues
      const updatedLearners = dataToUse.filter(
        (learner) => !newToggle.includes(learner.lenId),
      );
      setLearner(updatedLearners);

      setSelectedIndices([]);
    } else {
      const cohortsToMove = allSelected
        ? cohortsList.map((item: any) => item.chId)
        : SelectedcohortIndices;

      if (cohortsToMove.length === 0) return;

      const newToggle = [...new Set([...selectedCohorts, ...cohortsToMove])];
      setSelectedCohorts(newToggle);

      const updatedCohorts = showFiltercohorts.filter(
        (cohort) => !newToggle.includes(cohort.chId),
      );
      setCohortsList(updatedCohorts);

      setSelectedcohortIndices([]);
    }

    setAllSelected(false);
  };




// const handleMoveTo = () => {
//   if (tab === 'learners') {
//     // 1️⃣ Get learners to move
//     const learnersToMove = allSelected
//       ? showLearner.map((l) => l.lenId)
//       : selectedIndices;

//     if (!learnersToMove?.length) return;

//     // 2️⃣ Add to Enrolled locally
//     setSelectedToggle((prev: any) => [...prev, ...learnersToMove]);

//     // 3️⃣ Remove from Choose side locally
//     setLearner((prev: any) =>
//       prev.filter((l: any) => !learnersToMove.includes(l.lenId))
//     );

//     // 4️⃣ Reset selections
//     setSelectedIndices([]);
//     setAllSelected(false);
//   } else {
//     // ---------------- Cohorts logic ----------------
//     const cohortsToMove = allSelected
//       ? cohortsList.map((c) => c.chId)
//       : SelectedcohortIndices;

//     if (!cohortsToMove?.length) return;

//     setSelectedCohorts((prev: any) => [...prev, ...cohortsToMove]);
//     setCohortsList((prev: any) =>
//       prev.filter((c: any) => !cohortsToMove.includes(c.chId))
//     );
//     setSelectedcohortIndices([]);
//     setAllSelected(false);
//   }
// };

  const SearchEmail = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const searchemail = e.currentTarget.value.trim();
    const getSearchmail = dataToUse.filter((learner) =>
      learner.lenMail.toLowerCase().includes(searchemail.toLowerCase()),
    );
    setLearner(getSearchmail); // Filter learners based on search
    setSelectedIndices([]); // Reset selected learners
    setAllSelected(false); // Uncheck "Select All"
    setIsPasting(true);
  };
  const handlePasteGmails = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('Text');
    const emails = pastedData.split(/[\s,]+/); // Split pasted content by spaces or commas
    const validGmails = emails.filter(
      (email) => validateGmail(email) && !gmailList.includes(email),
    );
    setGmailList([...gmailList, ...validGmails]); // Add valid Gmail addresses to the state
    setIsPasting(true);
    setSelectedIndices([]); // Reset selected learners when pasting
    setAllSelected(false); // Uncheck "Select All"
    e.currentTarget.value = ''; // Clear the textarea
  };
  const validateGmail = (email: string) => {
    const gmailPattern = /^[^@]+@[^@]+$/; // Ensures there is only one @ and text before/after it
    return gmailPattern.test(email);
  };
  const handleClearGmails = () => {
    setGmailList([]); // Clear all Gmail tags
    setLearner(dataToUse);
  };
  const handleRemoveGmail = (gmailToRemove: any) => {
    setGmailList(gmailList.filter((gmail) => gmail !== gmailToRemove));
  };

  const handlAddUi = (i: any) => {
    setAddI(i);
  };
  const handleIconClick = (e: React.MouseEvent, index: number) => {
    e.stopPropagation();
    setSelectedIndices([]);
    setAllSelected(false);
    setAllSelected(false);
  };
  const handlecohortClick = (e: React.MouseEvent, index: number) => {
    e.stopPropagation();
    setSelectedcohortIndices([]);
    setAllSelected(false);
  };

 

  const handleBoxClick = (index: number) => {
  const id = showLearner[index]?.lenId;
  if (!id) return;

  setSelectedIndices((prev) =>
    prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
  );
};
  const handleBoxcohortClick = (index: number) => {
    const id = cohortsList[index]?.chId;
    if (!id) return; // handle edge case

    setSelectedcohortIndices((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };



  useEffect(() => {
  setAllSelected(false);
  setSelectedIndices([]);
  setSelectedcohortIndices([]);
  setGmailList([]);
  setFil('');
}, [tab]);
  useEffect(() => {
    if (showLearner.length > 0) {
      setAllSelected(selectedIndices.length === showLearner.length);
    } else {
      setAllSelected(false); // ## Ensure checkbox is unchecked when no learners are visible
    }
  }, [selectedIndices, showLearner.length]);
  useEffect(() => {
    if (cohortsList.length > 0) {
      setAllSelected(SelectedcohortIndices.length === cohortsList.length);
    } else {
      setAllSelected(false); // ## Ensure checkbox is unchecked when no cohorts are available
    }
  }, [SelectedcohortIndices, cohortsList.length]);
  useEffect(() => {
    if (showLearner.length === 0) {
      setAllSelected(false);
    }
  }, [showLearner]);
  useEffect(() => {
    if (cohortsList.length === 0) {
      setAllSelected(false);
    }
  }, [cohortsList]);
  const [prevTab, setPrevTab] = useState(tab);
  useEffect(() => {
    setAllSelected(false);
  }, [tab]);




 const handleRemoveFromEnrolledLearners = async (learnerId: any, lenCohorts: any) => {
  let data = { lenCohortsdata: lenCohorts };

  // ✅ Move back to Choose side WITHOUT duplicates
  const deletedLearner = dataToUse.find((l) => l.lenId === learnerId);
  if (deletedLearner) {
    setLearner((prev: any) => {
      // ## Filter out duplicates
      const exists = prev.find((l: any) => l.lenId === deletedLearner.lenId);
      if (exists) return prev;
      return [deletedLearner, ...prev];
    });
  }

  // ✅ Remove from Enrolled side
  setSelectedToggle((prevToggle: any) => prevToggle.filter((id: any) => id !== learnerId));
  setSelectedIndices([]);
  setAllSelected(false);

  // ✅ API call
  const result = await removeassignedlearner(learnerId, assignGameId, JSON.stringify(data));
  if (result?.status === 'Success') {
    getlist();
  }
};




const handleDelete = async (chIdGa: any) => {
  const deletedCohort = showFiltercohorts.find((c) => c.chId === chIdGa);
  if (deletedCohort) {
    setCohortsList((prev: any) => {
      // ## Filter out duplicates
      const exists = prev.find((c: any) => c.chId === deletedCohort.chId);
      if (exists) return prev;
      return [deletedCohort, ...prev];
    });
  }

  setSelectedCohorts((prevToggle: any) => prevToggle.filter((id: any) => id !== chIdGa));
  setSelectedcohortIndices([]);
  setAllSelected(false);

  const result = await removeAssignedCohort(chIdGa, assignGameId);
  if (result.status === 'Success') {
    getlist();
  }
};

useEffect(() => {
  if (tab === 'learners') {
    setAllSelected(selectedIndices.length === showLearner.length && showLearner.length > 0);
  } else {
    setAllSelected(SelectedcohortIndices.length === cohortsList.length && cohortsList.length > 0);
  }
}, [selectedIndices, SelectedcohortIndices, showLearner, cohortsList]);


  const handleTabClick = (newTab: any) => {
    if (allSelected) {
      setAllSelected(false);
    }
    setTab(newTab);
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Flex
        _before={{
          content: '""',
          background: '#1b1b1c4a',
          height: '100%',
          width: '100%',
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
        }}
      >
        <Card
          position="fixed"
          top="50%"
          left="50%"
          transform="translate(-50%, -45%)"
          background="#fff"
          width={{ base: '90%', md: '50%' }}
          p="20px"
          display="flex"
          alignItems="center"
          boxShadow="1px 2px 17px #42414556"
          mb="20px"
        >
          <Flex align="center" w="100%" justify="space-between" mb="10px">
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mb="4px"
            >
              {tab === 'learners' ? 'Assign Learners' : 'Assign Cohorts'}
            </Text>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mb="4px"
            >
              <Icon
                as={MdClose}
                cursor="pointer"
                onClick={() => setOpenLearner(false)}
              />
            </Text>
          </Flex>
          <Tabs variant="enclosed" w="100%">
            <TabList>
              <Tab
                _selected={{ bg: '#3311db', color: 'white' }}
                color={textColorPrimary}
                fontWeight="bold"
                fontSize="md"
                onClick={() => {
                  setTab('learners');
                  setAllSelected(false);
                }}
              >
                Learners
              </Tab>
              <Tab
                _selected={{ bg: '#3311db', color: 'white' }}
                color={textColorPrimary}
                fontWeight="bold"
                fontSize="md"
                onClick={() => {
                  setTab('Cohorts');
                  setAllSelected(false);
                }}
              >
                Cohorts
              </Tab>
            </TabList>
            <Box w="100%" mb="10px" mt="10px">
              <TabPanels>
                <TabPanel>
                  <SimpleGrid columns={{ base: 1, md: 1 }} mt={'10px'}>
                    <Box>
                      <Flex
                        direction="row"
                        p="12px"
                        wrap="wrap"
                        bg="transparent"
                        border="1px solid"
                        borderColor={borderColor}
                        borderRadius="16px"
                        _focus={{ borderColor: 'teal.300' }}
                        minH="30px"
                        maxH="300px !important"
                        h="stretch"
                        cursor="text"
                        style={{
                          overflowY: 'auto',
                          border: gmailList.length
                            ? '1px solid '
                            : '1px solid #ccc',
                        }}
                      >
                        {gmailList.map((gmail, index) => (
                          <Tag
                            fontSize="xs"
                            h="25px"
                            mb="6px"
                            me="6px"
                            borderRadius="12px"
                            variant="solid"
                            bg={lightBlue}
                            key={index}
                          >
                            <TagLabel w="100%" color={textColor}>
                              {gmail}
                            </TagLabel>
                            <TagCloseButton
                              justifySelf="flex-end"
                              color="black"
                              onClick={() => handleRemoveGmail(gmail)} // Handle removing email
                            />
                          </Tag>
                        ))}

                        <textarea
                          ref={textareaRef}
                          onPaste={handlePasteGmails}
                          onChange={(e: any) => SearchEmail(e)}
                          style={gmailstyles.textareaStyle}
                          placeholder="Multi-search learner emails"
                        ></textarea>
                        {gmailList.length > 0 && (
                          <button
                            onClick={handleClearGmails}
                            style={{
                              position: 'absolute', // Fixed position relative to the parent Box
                              right: '50px', // Adjust as needed
                              zIndex: 1, // Ensure it's above other content
                            }}
                          >
                            Clear All
                          </button>
                        )}
                      </Flex>
                    </Box>
                  </SimpleGrid>
                </TabPanel>
                <TabPanel>
                  <InputGroup w={{ base: '100%', md: '50%' }}>
                    <InputLeftElement
                      children={
                        <IconButton
                          aria-label="search"
                          bg="inherit"
                          borderRadius="inherit"
                          _active={{
                            bg: 'inherit',
                            transform: 'none',
                            borderColor: 'transparent',
                          }}
                          _hover={{
                            background: 'none',
                          }}
                          _focus={{
                            background: 'none',
                            boxShadow: 'none',
                          }}
                          icon={
                            <SearchIcon
                              color={searchIconColor}
                              w="15px"
                              h="15px"
                            />
                          }
                        />
                      }
                    />
                    <Input
                      type="text"
                      placeholder="Search cohorts name"
                      value={fil || ''}
                      onChange={(e) => FilterList(e.target.value)}
                      bg={'#f9f9f9'}
                      borderRadius={'14px'}
                      w={'100%'}
                    />
                    {fil && (
                      <InputRightElement
                        children={
                          <IconButton
                            aria-label="clear"
                            bg="inherit"
                            borderRadius="inherit"
                            _active={{
                              bg: 'inherit',
                              transform: 'none',
                              borderColor: 'transparent',
                            }}
                            _hover={{
                              background: 'none',
                            }}
                            _focus={{
                              background: 'none',
                              boxShadow: 'none',
                            }}
                            icon={
                              <CloseIcon color="gray.500" w="10px" h="10px" />
                            }
                            onClick={() => {
                              setFil('');
                              setCohortsList(showFiltercohorts);
                            }} // Clear the input field
                          />
                        }
                      />
                    )}
                  </InputGroup>
                </TabPanel>
              </TabPanels>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              w="50%"
            >
              <Checkbox isChecked={allSelected} onChange={handleChange}>
                Select All
              </Checkbox>
              {(allSelected ||
                SelectedcohortIndices.length > 1 ||
                selectedIndices.length > 1) && (
                <Button
                  ml="auto"
                  variant="outline"
                  borderColor="darkBrand"
                  color="darkBrand"
                  fontSize="sm"
                  fontWeight="500"
                  borderRadius="70px"
                  px="24px"
                  py="5px"
                  onClick={handleMoveTo}
                >
                  Move to
                  <Icon
                    as={GoMoveToEnd}
                    style={{
                      color: 'darkBrand',
                      marginLeft: '8px',
                      width: '1.2em',
                      height: '1.2em',
                    }}
                  />
                </Button>
              )}
            </Box>

            <TabPanels>
              <TabPanel>
                <Box
                  width={'100%'}
                  display={'flex'}
                  flexDirection={{ base: 'column', lg: 'row' }}
                >
                  <Box w={{ md: '100%', lg: '50%' }}>
                    <Text
                      mb="10px"
                      color="textColorPrimary"
                      fontWeight="bold"
                      fontSize="md"
                    >
                      Choose Learners
                    </Text>
                    <Box maxH="225px" overflowY="auto">
                      {showLearner &&
                        showLearner
                          .filter(
                            (learner: any) =>
                              !selectedToggle.includes(learner.lenId),
                          )
                          .map((chunk: any, index: number) => (
                            <Box
                              key={index}
                              style={{
                                border: selectedIndices.includes(
                                  showLearner[index].lenId,
                                )
                                  ? '2px solid #11047A'
                                  : '2px solid #e1e1e1',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                padding: '10px',
                                margin: '5px',
                                position: 'relative',
                              }}
                              display="flex"
                              justifyContent="space-between"
                              onMouseEnter={() => setAddI(index)}
                              onMouseLeave={() => setAddI(null)}
                              onClick={() => handleBoxClick(index)}
                            >
                              <Text>
                                {chunk.lenMail} / {chunk.lenUserName}
                              </Text>
                              {addI === index && (
                                <Icon
                                  as={IoAddCircleSharp}
                                  style={{
                                    color: '#11047a',
                                    cursor: 'pointer',
                                    width: '1.2em',
                                    height: '1.2em',
                                  }}
                                  onClick={(e) => {
                                    handleIconClick(e, index);
                                    handleClick(chunk.lenId, 'Learner');
                                  }}
                                />
                              )}
                            </Box>
                          ))}
                    </Box>
                  </Box>
                  <Box w={{ md: '100%', lg: '50%' }}>
                    <Text
                      mb="10px"
                      color={textColorPrimary}
                      fontWeight="bold"
                      fontSize="md"
                    >
                      Enrolled Learners
                    </Text>
                    <Box maxH="225px" overflowY="auto">
                      {showLearner &&
                        dataToUse
                          .filter((learner) =>
                            selectedToggle.includes(learner.lenId),
                          )
                          .reverse()
                          .map((chunk, index) => (
                            <Box
                              key={index}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                margin: '5px',
                              }}
                              role="group"
                              display={'flex'}
                              alignItems={'center'}
                              borderRadius={'10px'}
                              _hover={{ background: 'lightgray' }}
                            >
                              <Icon
                                as={MdDelete}
                                visibility={{ sm: 'visible', md: 'hidden' }}
                                _groupHover={{ visibility: 'visible' }}
                                style={{
                                  marginRight: '5px',
                                  cursor: 'pointer',
                                }}
                                tabIndex={1}
                                onClick={() => {
                                  setSelectedLearnerId(chunk.lenId);
                                  setIsPopupOpen1(true);
                                }}
                              />
                              <Text>
                                {chunk.lenMail} / {chunk.lenUserName}
                              </Text>
                              {isPopupOpen1 &&
                                selectedLearnerId === chunk.lenId && (
                                  <Flex
                                    _before={{
                                      content: '""',
                                      background: '#1b1b1c03',
                                      height: '100%',
                                      width: '100%',
                                      position: 'fixed',
                                      top: '0',
                                      left: '0',
                                      right: '0',
                                    }}
                                    position="fixed"
                                    top="0"
                                    left="0"
                                    align="center"
                                    justify="center"
                                    zIndex="modal"
                                    p="10px" // Added padding to prevent edge touching
                                  >
                                    <Card
                                      position="fixed"
                                      top="50%"
                                      left="50%"
                                      transform="translate(-50%, -50%)"
                                      background="#fff"
                                      width={{
                                        base: '87%',
                                        sm: '87%',
                                        md: '87%',
                                        lg: '500px',
                                      }}
                                      display="flex"
                                      alignItems="center"
                                      boxShadow="1px 2px 17px #42414556"
                                      p="20px"
                                    >
                                      <Text
                                        display="flex"
                                        w="100%"
                                        mb="15px"
                                        textAlign="center"
                                      >
                                        Are you sure to delete?
                                      </Text>
                                      <Flex justify="center" w="100%" mt="15px">
                                        <Button
                                          variant="solid"
                                          colorScheme="blue"
                                          fontSize="sm"
                                          fontWeight="500"
                                          borderRadius="md"
                                          px="24px"
                                          py="5px"
                                          onClick={() => {
                                            handleRemoveFromEnrolledLearners(
                                              chunk.lenId,
                                              chunk.lenCohorts,
                                            );
                                            setIsPopupOpen1(false);
                                          }}
                                        >
                                          Yes
                                        </Button>
                                        <Button
                                          variant="outline"
                                          colorScheme="gray"
                                          fontSize="sm"
                                          fontWeight="500"
                                          borderRadius="md"
                                          ml="10px"
                                          // onClick={() => handleCancel('learner')}
                                          onClick={() => setIsPopupOpen1(false)}
                                        >
                                          Cancel
                                        </Button>
                                      </Flex>
                                    </Card>
                                  </Flex>
                                )}
                            </Box>
                          ))}
                    </Box>
                  </Box>
                </Box>
              </TabPanel>
              <TabPanel>
                <Box
                  width={'100%'}
                  display={'flex'}
                  flexDirection={{ base: 'column', lg: 'row' }}
                >
                  <Box w={{ md: '100%', lg: '50%' }}>
                    <Text
                      mb="10px"
                      color={textColorPrimary}
                      fontWeight="bold"
                      fontSize="md"
                    >
                      Choose Cohorts
                    </Text>
                    <Box maxH="225px" overflowY="auto">
                      {cohortsList &&
                        cohortsList
                          .filter(
                            (cohort: any) =>
                              !selectedCohorts.includes(cohort.chId),
                          )
                          .map((chunk: any, index: any) => (
                            <Box
                              key={index}
                              style={{
                                border: SelectedcohortIndices.includes(
                                  cohortsList[index].chId,
                                )
                                  ? '2px solid #11047A' // Selected box border color
                                  : '2px solid #e1e1e1', // Default box border color
                                borderRadius: '8px',
                                cursor: 'pointer',
                                padding: '10px',
                                margin: '5px',
                                position: 'relative',
                              }}
                              display={'flex'}
                              justifyContent={'space-between'}
                              onMouseEnter={() => handlAddUi(index)}
                              onMouseLeave={() => setAddI(null)}
                              onClick={() => handleBoxcohortClick(index)}
                            >
                              <Text>{chunk.chCohortsName}</Text>
                              {addI === index && (
                                <Icon
                                  as={IoAddCircleSharp}
                                  style={{
                                    color: '#11047a',
                                    cursor: 'pointer',
                                    width: '1.2em',
                                    height: '1.2em',
                                  }}
                                  onClick={(e) => {
                                    handlecohortClick(e, index);
                                    handleClick(chunk.chId, 'cohorts');
                                  }}
                                />
                              )}
                            </Box>
                          ))}
                    </Box>
                  </Box>
                  <Box w={{ md: '100%', lg: '50%' }}>
                    <Text
                      mb="10px"
                      color={textColorPrimary}
                      fontWeight="bold"
                      fontSize="md"
                    >
                      Enrolled Cohorts
                    </Text>
                    <Box maxH="225px" overflowY="auto">
                      {cohortsList &&
                        showFiltercohorts
                          .filter((cohort) =>
                            selectedCohorts.includes(cohort.chId),
                          )
                          .map((chunk, index) => (
                            <Box
                              key={index}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                margin: '5px',
                              }}
                              role="group"
                              display={'flex'}
                              alignItems={'center'}
                              borderRadius={'10px'}
                              _hover={{ background: 'lightgray' }}
                            >
                              <Icon
                                as={MdDelete}
                                visibility={{ sm: 'visible', md: 'hidden' }}
                                _groupHover={{ visibility: 'visible' }}
                                style={{
                                  marginRight: '5px',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  setSelectedCohortId(chunk.chId);
                                  setIsPopupOpen(true);
                                }}
                                tabIndex={1}
                              />
                              <Text>{chunk.chCohortsName}</Text>

                              {isPopupOpen &&
                                selectedCohortId === chunk.chId && (
                                  <Flex
                                    _before={{
                                      content: '""',
                                      background: '#1b1b1c03',
                                      height: '100%',
                                      width: '100%',
                                      position: 'fixed',
                                      top: '0',
                                      left: '0',
                                      right: '0',
                                    }}
                                    position="fixed"
                                    top="0"
                                    left="0"
                                    align="center"
                                    justify="center"
                                    zIndex="modal"
                                    p="10px" // Added padding to prevent edge touching
                                  >
                                    <Card
                                      position="fixed"
                                      top="50%"
                                      left="50%"
                                      transform="translate(-50%, -50%)"
                                      background="#fff"
                                      width={{
                                        base: '87%',
                                        sm: '87%',
                                        md: '87%',
                                        lg: '500px',
                                      }}
                                      display="flex"
                                      alignItems="center"
                                      boxShadow="1px 2px 17px #42414556"
                                      p="20px"
                                    >
                                      <Text
                                        display="flex"
                                        w="100%"
                                        mb="15px"
                                        textAlign="center"
                                      >
                                        Are you sure to delete?
                                      </Text>
                                      <Flex justify="center" w="100%" mt="15px">
                                        <Button
                                          variant="solid"
                                          colorScheme="blue"
                                          fontSize="sm"
                                          fontWeight="500"
                                          borderRadius="md"
                                          px="24px"
                                          py="5px"
                                          // onClick={handleRemoveItem}
                                          onClick={() => {
                                            handleDelete(chunk.chId);
                                            setIsPopupOpen(false);
                                          }}
                                        >
                                          Yes
                                        </Button>
                                        <Button
                                          variant="outline"
                                          colorScheme="gray"
                                          fontSize="sm"
                                          fontWeight="500"
                                          borderRadius="md"
                                          ml="10px"
                                          // onClick={() => handleCancel('learner')}
                                          onClick={() => setIsPopupOpen(false)}
                                        >
                                          Cancel
                                        </Button>
                                      </Flex>
                                    </Card>
                                  </Flex>
                                )}
                            </Box>
                          ))}
                    </Box>
                  </Box>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
          <Flex align="right" justify="flex-end" w="100%">
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mb="4px"
            >
              {/* Your text content */}
            </Text>
            <Button
              ml="auto" // Use 'ml="auto"' to push the button to the right
              variant="darkBrand"
              color="white"
              fontSize="sm"
              fontWeight="500"
              borderRadius="70px"
              px="24px"
              py="5px"
              onClick={handleAssign}
            >
              Assign Game
            </Button>
          </Flex>
        </Card>
      </Flex>
    </>
  );
};
export default LeanersList;
const gmailstyles: { [name: string]: React.CSSProperties } = {
  container: {
    marginTop: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textareaDefaultStyle: {
    padding: 5,
    width: '100%',
    display: 'block',
    resize: 'none',
    backgroundColor: 'white',
    borderRadius: '12px',
    borderColor: '#E0E5F2', // Border color
    outlineColor: '#E0E5F2', // Outline color
    borderWidth: '1px', // Border width
    borderStyle: 'solid', // Border style
    overflow: 'auto', // Hide the scrollbar
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#1b2559',
  },
  textareaStyle: {
    padding: 2,
    width: '100%',
    // marginLeft:'10px',
    display: 'block',
    resize: 'none',
    backgroundColor: 'white',
    borderRadius: '12px',
    borderColor: 'white', // Border color
    outlineColor: 'white', // Outline color
    borderWidth: '1px', // Border width
    borderStyle: 'solid', // Border style
    overflow: 'hidden',
  },
  labelStyle: {
    display: 'block',
    fontSize: 'smaller',
    fontWeight: 'bold',
    marginBottom: '5px', // Add margin to separate label and textarea
    marginRight: '430px',
  },
  labelLearningStyle: {
    display: 'block',
    fontSize: 'smaller',
    fontWeight: 'bold',
    marginBottom: '5px', // Add margin to separate label and textarea
    marginRight: '370px',
  },
};